import { debounce } from 'lodash';
import { updateStacks } from './updateStacks';
import { initializeGanttReadjustmentCounters } from './initializeGanttReadjustmentCounters';
import { refreshCriticalPathIsNeeded } from './refreshCriticalPathIsNeeded';
import { updateExpectedProgress } from '../utils/updateExpectedGlobal';

import { reloadDuration, requestRender } from '../utils/index';
import { earlyAccessCriticalPath } from '../../../../utils/earlyAccessCriticalPath';

const AUTOSCHEDULE_MILESTONE_THRESHOLD = 2;
const CRITICAL_PATH_DEBOUNCE_MS = 1000;

function _performAutoScheduleActions(gantt) {
  gantt.autoscheduleNumber++;
  if (gantt.autoscheduleNumber === AUTOSCHEDULE_MILESTONE_THRESHOLD) {
    gantt.disableAutoscheduleForMilestonesWithProgress();
  }
  if (gantt.isPasting) return;
  gantt.is_autoscheduling = false;
  reloadDuration(gantt);
  if (gantt.clearStacks) {
    updateStacks();
    gantt.clearStacks = false;
  }

  updateExpectedProgress({ immediate: true, avoidRender: true });

  initializeGanttReadjustmentCounters();

  if (window.initializingGantt) {
    window.dispatchEvent(new Event('autoScheduleFinished'));
    window.__hasFinishedAutoSchedule = true;
  } else {
    requestRender();
  }

  refreshCriticalPath();
}

const onAfterAutoSchedule = () => {
  const gantt = window.to_use_react_gantt;
  _performAutoScheduleActions(gantt);
}

const debouncedCriticalPath = debounce(() => {
  refreshCriticalPathIsNeeded();
}, CRITICAL_PATH_DEBOUNCE_MS);

function refreshCriticalPath() {
  if (earlyAccessCriticalPath()) {
    return debouncedCriticalPath();
  }
  refreshCriticalPathIsNeeded();
}

export { onAfterAutoSchedule };
